module.exports = __webpack_public_path__ + "static/media/category-default-icon-dwa.f9d1038b.jpeg";